const container = document.querySelector(".gallery-card__grid");
const sentinel = document.getElementById("sentinel");

sentinel.addEventListener("click", () => {
  renderBatch();
});

let filtered = [...items];
let start = 0;
const BATCH_SIZE = 2000;

// --- CREATE CARD ---
function createCard(item) {
  const card = document.createElement("card-gallery-item");
  card.dataset.id = String(item.id); // <- for quick lookup
  card.classList.add("card-gallery-item"); // optional base class
  //<p style="background:#fff;position:absolute;z-index:1">${item.order}</p>
  card.innerHTML = `
    <div class="shine gallery-card__image-wrapper card-${item.rarity}">
      <img src="${item.image}?width=100" srcset="${item.image}?width=100 100w, ${item.image}?width=150 150w, ${item.image}?width=200 200w, ${item.image}?width=250 250w, ${item.image}?width=300 300w,${item.image}?width=600 600w,${item.image}?width=900 900w" sizes="(min-width: 990px) 14vw, 33vw" class="gallery-card__image" alt="${item.id}" loading="lazy">
    </div>
  `;
  return card;
}
// --- RENDER BATCH ---
function renderBatch() {
  const fragment = document.createDocumentFragment();
  const end = Math.min(start + BATCH_SIZE, filtered.length);

  for (let i = start; i < end; i++) {
    const item = filtered[i];

    // Try to find an existing card for this item
    let card = container.querySelector(
      `card-gallery-item[data-id="${item.id}"]`
    );

    if (!card) {
      // not in DOM yet — create it
      card = createCard(item);
      fragment.appendChild(card);
    }

    // mark as active
    card.classList.add("card-gallery-item--active");
  }

  if (fragment.childNodes.length) container.appendChild(fragment);

  start = end;

  // Hide sentinel if all items are loaded
  sentinel.style.display = start >= filtered.length ? "none" : "block";
}

// --- FILTER + SORT ---
function filterAndSort(selectedRarities = ["all"], order = "asc") {
  start = 0;

  const activeFiltersSize = selectedRarities.length;

  // compute filtered list
  filtered = selectedRarities.includes("all")
    ? [...items]
    : items.filter((i) => selectedRarities.includes(i.rarity));

  //filtered.sort((a, b) => (order === "asc" ? a.id - b.id : b.id - a.id));

  // Mark all existing cards as inactive
  container.querySelectorAll(".card-gallery-item--active").forEach((el) => {
    el.classList.remove("card-gallery-item--active");
    //el.classList.add("card-gallery-item--exiting");
    //el.addEventListener("transitionend", () => el.remove(), { once: true });
  });

  // Render + activate new set
  renderBatch();
}
// --- INFINITE SCROLL OBSERVER ---
const sentinelObserver = new IntersectionObserver((entries) => {
  const entry = entries[0];
  console.log("sentinel observed");
  if (entry.isIntersecting && start < filtered.length) renderBatch();
});

sentinelObserver.observe(sentinel);

// --- FILTER CONTROL ---
function getSelected(name) {
  const checkboxes = document.querySelectorAll(`input[name="${name}"]:checked`);
  if (checkboxes.length === 0) {
    return ["all"];
  }
  return [...checkboxes].map((cb) => cb.value);
}

document
  .querySelectorAll(".filter-group input[type='checkbox']")
  .forEach((cb) => {
    cb.addEventListener("input", () => {
      applyAllFilters();
    });
  });

document.querySelectorAll("[data-reset-filter]").forEach((button) => {
  button.addEventListener("click", () => {
    const filterType = button.getAttribute("data-reset-filter");

    document
      .querySelectorAll(`input[name="${filterType}"]`)
      .forEach((cb) => (cb.checked = false));

    applyAllFilters();
  });
});

function updateURL() {
  const params = new URLSearchParams();

  document.querySelectorAll("[data-filter]").forEach((group) => {
    const filterType = group.getAttribute("data-filter");
    const selected = getSelected(filterType);

    if (!selected.includes("all")) {
      selected.forEach((val) => params.append(filterType, val));
    }
  });

  const newUrl =
    params.toString().length > 0
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;

  history.replaceState({}, "", newUrl);
}
function initFiltersFromURL() {
  const params = new URLSearchParams(window.location.search);

  document.querySelectorAll("[data-filter]").forEach((group) => {
    const filterType = group.getAttribute("data-filter");
    const values = params.getAll(filterType);

    if (values.length > 0) {
      // uncheck all first
      document
        .querySelectorAll(`input[name="${filterType}"]`)
        .forEach((cb) => (cb.checked = false));

      // check URL values
      values.forEach((v) => {
        const cb = document.querySelector(
          `input[name="${filterType}"][value="${v}"]`
        );
        if (cb) cb.checked = true;
      });
    }
  });

  // Collect all filters and render
  applyAllFilters();
}
function applyAllFilters() {
  const activeFilters = {};

  document.querySelectorAll("[data-filter]").forEach((group) => {
    const filterType = group.getAttribute("data-filter");
    activeFilters[filterType] = getSelected(filterType);
  });

  // Currently filterAndSort is tied to rarity
  // You can extend it later to handle multiple filter types
  filterAndSort(activeFilters["rarity"]);
  updateFilterGroup();
  updateURL();
}

function updateFilterGroup() {
  const filterGroup = document.querySelectorAll("[data-filter]");

  filterGroup.forEach((group) => {
    const filterType = group.getAttribute("data-filter");
    const activeFilters = getSelected(filterType);

    const groupActive = activeFilters.includes("all");

    group.querySelector("sup").textContent = groupActive
      ? ""
      : activeFilters.length;

    const resetButton = group.querySelector(".filter-group__reset");

    groupActive
      ? resetButton.classList.remove("filter-group__reset--active")
      : resetButton.classList.add("filter-group__reset--active");
  });
}

function applyFilters() {
  filterAndSort("all");
}

applyFilters(); // initial render
initFiltersFromURL();
